import { createAction, props } from '@ngrx/store';
import { AppError } from 'src/app/ngrx-message/models/client/app-error';

export const upsertAppError = createAction(
  '[AppError] Upsert an App Error',
  props<{ appError: AppError }>(),
);
export const removeAppErrors = createAction('[AppError] Remove all App Errors');
